import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import styled from 'styled-components';
import { connect } from 'react-redux';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import ChevronDownIcon from 'mdi-material-ui/ChevronDown';

import Actions from 'views/Layout/Header/elements/Actions';
import NavBar from 'views/Layout/Header/elements/NavBar';
import MegaItem from './elements/MegaItem';
import TopBar from './elements/TopBar';

const FlexNav = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  margin-left: 14px;
`;

const MegaPaper = styled(Paper)`
  position: absolute;
  padding: 64px 0 0 0;
  width: 100%;
  z-index: 1298;
  transform: ${props => (props.in ? `scaleY(1)` : `scaleY(0)`)};
  transform-origin: top center;
  transition: ${props => (props.in ? `all 0.1s ease-in-out` : `none`)};
`;

const MegaNavButton = styled(Button)`
  margin-left: 14px;
  &:hover {
    background-color: transparent;
    svg {
      opacity: 1;
    }
  }
  svg {
    opacity: ${props => (props.active ? 1 : 0.25)};
  }
`;

const DesktopNav = ({ stack }) => {
  const [activeItem, setActiveItem] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setActiveItem(null);
  }, [location]);

  const debouncedSetActiveItem = useCallback(
    _.debounce(idx => setActiveItem(idx), 250),
    []
  );
  const handleMenuLeave = useCallback(() => {
    setTimeoutId(
      setTimeout(() => {
        setActiveItem(null);
      }, 500)
    );
  }, []);

  const handleMenuEnter = () => {
    clearTimeout(timeoutId);
  };

  return (
    <>
      <TopBar />
      <ClickAwayListener onClickAway={() => setActiveItem(null)}>
        <div onMouseLeave={handleMenuLeave} onMouseEnter={handleMenuEnter}>
          <NavBar colorOverride={activeItem !== null ? 'primary' : null}>
            <FlexNav>
              <div>
                {(stack.primary || []).map(
                  (item, idx) =>
                    item.main_item && (
                      <MegaNavButton
                        key={idx}
                        active={activeItem === idx}
                        onClick={() => setActiveItem(idx)}
                        onMouseEnter={() => debouncedSetActiveItem(idx)}
                      >
                        {item.main_item.label} <ChevronDownIcon />
                      </MegaNavButton>
                    )
                )}
              </div>
              <div>
                <Actions items={stack.actions} />
              </div>
            </FlexNav>
          </NavBar>
          <MegaPaper square elevation={12} in={activeItem !== null}>
            <Divider />
            {activeItem !== null && (
              <MegaItem
                sections={stack.primary[activeItem].main_item.sections}
              />
            )}
          </MegaPaper>
        </div>
      </ClickAwayListener>
    </>
  );
};

export default connect(
  state => ({
    stack: state.navigation.stack
  }),
  {}
)(DesktopNav);
